import { Col } from "react-bootstrap";

import Label from "lib/Label";
import ToolTipV1 from "lib/TooltipV1";
import ErrorMessage from "lib/ErrorMessage";

import "./index.scss";
import { gridValues } from "helper/destructureObject";

const RadioTemplate = (props) => {
  const {
    name,
    label,
    onChange,
    options,
    web_grid_col,
    mobile_grid_col,
    tooltip,
    tooltipText,
    value,
    class_name,
    error,
    size,
    validators,
    is_disabled,
    description,
    show_description,
    isEditable // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
  
  } = props;


  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  let gridData = gridValues(null ,options);
 
  return (
    <>
    <Label label={label}  tooltip={tooltip} validators={validators}/>

      <div className="radio-container">
        {
          options?.map((option) => {
            const { id, label, description ,for: htmlFor, is_disabled } = option;
            let radioId = name + id;
            return (
              <div  key={radioId} className={`${size} px-3`}>
                <div className={is_disabled ? "disable_ms form-radio" : "form-radio"} >
                  <input
                    id={radioId}
                    type="radio"
                    name={name}
                    className="radio_input"
                    onChange={(e) => onChange(e, description)}
                    value={label}
                    checked={value?.label === label  ? true : false}
                    disabled = {is_disabled ? true : isEditable ? false:true}
                  />
                  <label className={`radio_label options ${errorClass} ${!isEditable && "radioDisabled"}`} htmlFor={radioId}>
                    <div className="dot"></div>
                    <div className="radio-description"
                    >
                    <span>{label}</span> 
                    {show_description? 
                    <div className="description">{description}</div>
          :""}
                    </div>
                  </label>
                
                </div>
              </div>
            );
          })
        }
      </div>
      {error?.length !== 0 && <ErrorMessage error={error} />}
    </>
  );
};

export default RadioTemplate;
